import { render, staticRenderFns } from "./DocumentCopy.vue?vue&type=template&id=60f25f12&"
import script from "./DocumentCopy.vue?vue&type=script&lang=js&"
export * from "./DocumentCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports